import { useTextsSource } from "../../../contexts/texts.js";
function useTexts() {
  return useTextsSource().fields.username;
}
export {
  useTexts
};
//# sourceMappingURL=useTexts.js.map
